import { useEffect, useState } from 'react';

import axios from 'axios';
import SignupForm from 'components/invite-signup/invite-signup-form';
import { ErrorState, LoadingOlist } from 'components/layout';
import LogoOlist from 'images/logo-olist';
import { useTranslation } from 'react-i18next';
import { useAsyncFn } from 'react-use';
import { URL_LEAD_INFO } from 'utils/api-urls';

import { SectionSubheading, Title } from '@olist/design-system';
import { Container } from '@olist/templates';
import { Box, Flex } from '@olist/united';

export type LeadResponse = {
  documentNumber: string;
  email: string;
  name: string;
  phone: string;
  signupUrl: string;
};

const SignupPage = () => {
  const { t } = useTranslation();

  const inviteCode = window.location.pathname.replace(`/signup/`, '');
  const [lead, setLead] = useState<LeadResponse | null>(null);
  const [{ error, loading, value: userData }, getInvite] = useAsyncFn(
    async () => axios.get(URL_LEAD_INFO(inviteCode)),
    []
  );

  useEffect(() => {
    getInvite();
  }, [getInvite]);

  useEffect(() => {
    if (!userData) {
      return;
    }

    setLead(userData.data);
  }, [userData]);

  if (error) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <ErrorState onClick={() => window.location.reload()} />
      </Flex>
    );
  }

  if (loading || !lead) {
    return <LoadingOlist />;
  }

  return (
    <Container>
      <Flex mx={4} justifyContent="center" flexDirection="column">
        <Box mt={[2, 4]} mb={[2, 4]}>
          <LogoOlist />
        </Box>
        <Box mb={6}>
          <Title>{t`create your account`}</Title>
          <SectionSubheading>{t`start creating your access to olist platform`}</SectionSubheading>
        </Box>
        <SignupForm invite={{ ...lead }} />
      </Flex>
    </Container>
  );
};

export default SignupPage;
